import {useQuery} from '@tanstack/react-query';

interface MaintenanceStatus {
  maintenance?: boolean;
}

export function useMaintenanceMode() {
  const {data} = useQuery<MaintenanceStatus>({
    queryKey: ['maintenanceMode'],
    queryFn: () =>
      (
        fetch('/maintenance.json').then(r =>
          r.json()
        ) as Promise<MaintenanceStatus>
      ).catch(() => ({})),
    refetchInterval: 30_000,
    retry: false,
  });
  return data?.maintenance === true;
}
